export default {
  setCurrentDash (state, val) {
    state.currentDash = val
  },
  setDashOwner (state, val) {
    state.dashOwner = val
  },
  extractDashboardSheets (state, data) {
    if (!data) return
    if (!data.spreadsheets) {
      state.dashboardSheets = []
      return
    }
    let dashSheets = []
    let sheets = data.spreadsheets
    for (let sheet in sheets) {
      dashSheets.push(sheet)
      if (sheets[sheet].subsheets) {
        let subsheets = sheets[sheet].subsheets
        for (let subsheet in subsheets) {
          dashSheets.push(sheet + '.' + subsheet)
        }
      }
    }
    state.dashboardSheets = dashSheets
  },
  setDashboardSheetsCache (state, data) {
    state.$sheets = data
  },
  markUserAsAnonymous (state, val) {
    state.isUserAnonymous = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/dashboard.js